import { _ as __read, e as __awaiter, f as __generator } from '../../tslib.es6-14c74580.js';
import { useState, useEffect } from 'react';
import '../core/enums/GameSpecificTypes.js';
import '../core/enums/MaxPayoutDataTypes.js';
import '../core/enums/Chat.js';
import '../core/enums/GameModes.js';
import '../core/enums/IconTypes.js';
import '../core/enums/BetStatus.js';
import '../core/enums/PopupTypes.js';
import '../core/enums/ApiVersion.js';
import '../core/enums/RoundStatus.js';
import '../core/enums/FreeBetsStatus.js';
import '../core/enums/SocketEvents.js';
import '../core/enums/TranslationKeys.js';
import '../core/enums/TimeoutMaxValue.js';
import '../core/enums/ApiServiceTypes.js';
import '../core/enums/EnvironmentTypes.js';
import '../core/enums/DefaultQueryValues.js';
import '../core/enums/FreeBetWinningType.js';
import '../core/enums/DefaultQueryParams.js';
import '../core/enums/BetHistoryFilterTypes.js';
import '../core/enums/GameThemeTypes.js';
import '../core/enums/RequestStatus.js';
import '../core/enums/FetchDefaultPaths.js';
import '../core/enums/ResponseCodes.js';
import { $ as loadingStore } from '../../environmentBuilder-2cb7dcfa.js';
import '../core/store/chatStore.js';
import '../core/store/wageringStore.js';
import '../core/store/roundInfoStore.js';
import '../core/store/userCountStore.js';
import '../core/store/gameResultStore.js';
import '../core/store/resultHashStore.js';
import '../core/store/userWinBetsStore.js';
import '../core/store/notificationStore.js';
import '../core/store/selectedResultInfoStore.js';
import '../core/services/liveConnection/types.js';
import 'axios';
import '../core/services/sound/types.js';
import '../core/services/sound/SoundService.js';
import '../core/services/sound/defaultSounds.js';
import '../core/services/api/types.js';
import '../core/services/ApiServices.js';
import '../../momentFormat-14fce7b4.js';
import '../core/polyfill.js';
import 'mobx';
import '../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../core/enums/BogLineGameConfig.js';
import '../core/helpers/parseQuery.js';
import '../core/enums/StatisticsSortingTypes.js';
import '../core/services/api/BaseApiService.js';
import '../../table-line/t_types/enums/BetResponseCode.js';
import '../../table-line/t_types/enums/BetErrorMessages.js';
import '../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../table-line/t_types/enums/FreeChipTypes.js';
import '../../table-line/t_types/enums/PopupTypes.js';
import '../core/helpers/formatDate.js';
import '../core/helpers/isMobile.js';
import '../core/enums/bogGameNames.js';
import '../core/helpers/updateHalfBets.js';
import 'howler';
import '../../_commonjsHelpers-1a7a244d.js';

/**
 * get assets isLoaded states of assets (fonts, images, videos)
 * @param ref - element that will contain assets, by default take body tag
 */
var useAssetsLoadedState = function (ref) {
    var _a = __read(useState(false), 2), imagesLoadState = _a[0], setImagesLoadState = _a[1];
    var _b = __read(useState(false), 2), videosLoadState = _b[0], setVideosLoadState = _b[1];
    var _c = __read(useState(false), 2), webFontsLoaded = _c[0], setWebFontsLoaded = _c[1];
    var _d = __read(useState(false), 2), backgroundImagesLoaded = _d[0], setBackgroundImagesLoaded = _d[1];
    var checkBackgroundImages = function (elements, callback) {
        if (!elements.length) {
            callback();
            return;
        }
        var loadedCount = 0;
        elements.forEach(function (element) {
            var style = window.getComputedStyle(element);
            var backgroundImage = style.getPropertyValue('background-image');
            if (backgroundImage && backgroundImage !== 'none') {
                var urlMatch = /url\(["']?([^"')]+)["']?\)/.exec(backgroundImage);
                if (urlMatch && urlMatch[1]) {
                    var bgImage_1 = new Image();
                    bgImage_1.src = urlMatch[1];
                    bgImage_1.onload = function () {
                        loadedCount += 1;
                        if (loadedCount === elements.length) {
                            callback();
                        }
                    };
                    bgImage_1.onerror = function () {
                        console.error('Error loading background image:', bgImage_1.src);
                        loadedCount += 1;
                        if (loadedCount === elements.length) {
                            callback();
                        }
                    };
                }
                else {
                    loadedCount += 1;
                    if (loadedCount === elements.length) {
                        callback();
                    }
                }
            }
            else {
                loadedCount += 1;
                if (loadedCount === elements.length) {
                    callback();
                }
            }
        });
    };
    // FONTS LOAD
    useEffect(function () {
        function areFontsReady() {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, document.fonts.ready];
                        case 1:
                            _a.sent();
                            setWebFontsLoaded(true);
                            return [2 /*return*/];
                    }
                });
            });
        }
        areFontsReady();
    }, []);
    // IMAGES LOAD (including background images)
    useEffect(function () {
        if (ref) {
            var updateStatus_1 = function (resources) {
                setImagesLoadState(resources.every(function (image) { return image.complete; }));
            };
            var images_1 = Array.from(ref.querySelectorAll('img'));
            if (!images_1 || images_1.length === 0) {
                setImagesLoadState(true);
            }
            else {
                var notLoadedImages = images_1.filter(function (item) { return !item.complete; });
                if (notLoadedImages.length > 0) {
                    notLoadedImages.forEach(function (image) {
                        image.addEventListener('load', function () { return updateStatus_1(images_1); }, { once: true });
                        image.addEventListener('error', function () { return updateStatus_1(images_1); }, { once: true });
                    });
                }
                else {
                    setImagesLoadState(true);
                }
            }
            // Check for CSS background images
            var elementsWithBackgroundImages = Array.from(ref.querySelectorAll('*')).filter(function (element) {
                var bg = window.getComputedStyle(element).getPropertyValue('background-image');
                return bg && bg !== 'none';
            });
            checkBackgroundImages(elementsWithBackgroundImages, function () {
                setBackgroundImagesLoaded(true);
            });
        }
    }, [ref]);
    // VIDEOS LOAD
    useEffect(function () {
        if (ref) {
            var videoReadyStateCode_1 = 4;
            var updateStatus_2 = function (resources) {
                setVideosLoadState(resources.every(function (video) { return video.readyState === videoReadyStateCode_1; }));
            };
            var videos_1 = Array.from(ref.querySelectorAll('video'));
            if (!videos_1 || videos_1.length === 0) {
                setVideosLoadState(true);
            }
            else {
                var notLoadedVideos = videos_1.filter(function (video) { return video.readyState !== videoReadyStateCode_1; });
                if (notLoadedVideos.length > 0) {
                    notLoadedVideos.forEach(function (video) {
                        video.addEventListener('loadeddata', function () { return updateStatus_2(videos_1); }, { once: true });
                        video.addEventListener('error', function () { return updateStatus_2(videos_1); }, { once: true });
                    });
                }
                else {
                    setVideosLoadState(true);
                }
            }
        }
    }, [ref]);
    useEffect(function () {
        if (imagesLoadState && backgroundImagesLoaded && videosLoadState && webFontsLoaded) {
            loadingStore.updateLoading({ isAssetsIsLoaded: true });
        }
    }, [imagesLoadState, videosLoadState, webFontsLoaded, backgroundImagesLoaded]);
};

export { useAssetsLoadedState };
